import request from '@/utils/request'

export default {
  getCustodianAccounts(qry) {
    return request.post('/reference-data/getCustodianAccounts', qry)
  },
  createCustodianAccount(createCustodianAccountReq) {
    return request.post(
      '/reference-data/createCustodianAccount',
      createCustodianAccountReq
    )
  },
  updateCustodianAccount(custodianAccountDTO) {
    return request.post(
      '/reference-data/updateCustodianAccount',
      custodianAccountDTO
    )
  },
}
